"use client"

import { HTMLAttributes, useState } from "react"

import { cn } from "@/lib/utils"

export default function ClientDemoSection() {
  const [active, setActive] = useState(1)
  return (
    <div className="grid grid-cols-1 gap-x-24 lg:grid-cols-2 lg:items-start">
      <div className="">
        <dl className="mx-auto mt-6 max-w-2xl text-base leading-7 text-slate-600 lg:mx-0 lg:max-w-lg">
          <ClickableSection
            index="01"
            title="Register your boilerplate now"
            desc="Submit your boilerplate now and receive a response within 48 hours."
            onClick={() => setActive(1)}
            isActive={active === 1}
          />
          <ClickableSection
            index="02"
            title="Fight for the top spot"
            desc="Each week, the top 3 community-rated boilerplates are highlighted on the landing page and featured in the newsletter."
            onClick={() => setActive(2)}
            isActive={active === 2}
          />
          <ClickableSection
            index="03"
            title="Benefit from thousands of visitors each month"
            desc="Each month, over 5,000 visitors discover our platform. The higher your rating, the greater your chance of being seen."
            onClick={() => setActive(3)}
            isActive={active === 3}
          />
        </dl>
      </div>
      <div
        key={`video-key-${active}`}
        className="border-newPrimary/40 relative mt-10 h-[320px] w-full max-w-2xl overflow-hidden rounded-2xl border-[6px] bg-white"
      >
        {active === 1 ? (
          <video
            className="absolute inset-0 h-full w-full rounded-lg object-cover object-center"
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src="https://epkyoncdkuzoznax.public.blob.vercel-storage.com/register-now-txkCNQBwGycToecKnnThMFkY5zbT8I.mp4"
              type="video/mp4"
            />
          </video>
        ) : active === 3 ? (
          <video
            className="absolute inset-0 h-full w-full rounded-lg object-cover object-center"
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src="https://epkyoncdkuzoznax.public.blob.vercel-storage.com/analytics-DL6Y7wKjBQreB5vNM5tlaoscExczfp.mp4"
              type="video/mp4"
            />
          </video>
        ) : (
          <video
            className="absolute inset-0 h-full w-full rounded-lg object-cover object-center"
            playsInline
            autoPlay
            loop
            muted
          >
            <source
              src="https://epkyoncdkuzoznax.public.blob.vercel-storage.com/go-to-top-AFgc0uxSm3jQj7IDIzjv06HEHeIbZY.mp4"
              type="video/mp4"
            />
          </video>
        )}
      </div>
    </div>
  )
}

function ClickableSection({
  index,
  title,
  desc,
  isActive = false,
  ...props
}: {
  index: string
  title: string
  desc: string
  isActive: boolean
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cn(
        "hover:bg-primary/10 relative my-2 flex cursor-pointer flex-col items-start justify-center rounded-lg border border-transparent p-4 transition-all duration-300 ease-in-out",
        {
          "bg-primary/10": isActive,
        }
      )}
    >
      <dt className="font-display flex items-center font-semibold text-slate-900">
        <span className="text-primary mr-3 font-bold" aria-hidden="true">
          {index}
        </span>
        <h3 className="font-semibold">{title}</h3>
      </dt>
      <dd className="ml-9 inline">{desc}</dd>
    </div>
  )
}
